import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils";

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        carousel: "bg-[#F4F4F4] hover:bg-[#E5E5E5] border border-[#DFE6FF] shadow-[inset_0_4px_4px_rgba(0,0,0,0.1)] flex items-center justify-center text-[32px] text-gray-600 font-bold relative before:content-['<'] before:block before:leading-none",
        carouselLeft: "bg-[#F4F4F4] hover:bg-[#E5E5E5] border-r-0 border-[#DFE6FF] shadow-[inset_0_4px_4px_rgba(0,0,0,0.1)] flex items-center justify-center text-[32px] text-gray-600 font-bold relative rounded-r-[50px] before:content-['<'] before:block before:leading-none",
        carouselRight: "bg-[#F4F4F4] hover:bg-[#E5E5E5] border-l-0 border-[#DFE6FF] shadow-[inset_0_4px_4px_rgba(0,0,0,0.1)] flex items-center justify-center text-[32px] text-gray-600 font-bold relative rounded-l-[50px] before:content-['>'] before:block before:leading-none",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
        carousel: "min-w-[51px] min-h-[100px] w-[51px] h-[100px] px-0 py-0",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

const Button = React.forwardRef(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button";
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";

export { Button, buttonVariants };
